/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import $store from '../store'
import * as authService from '../services/auth.service'
import { API_URL } from '../.env'
import $router from '../router'

export default class Http {
  constructor (status) {
    this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: process.env.VUE_APP_URL
    })

    return this.init()
  }

  init () {
    if (this.isAuth) {
      this.instance.interceptors.request.use(request => {
        request.headers['authorization'] = authService.getAccessToken()
        return request;
        // if access token expired and refreshToken is exist >> go to API and get new access token
        /**if (authService.getAccessToken()) {
          return authService.refreshTokens()
            .then(response => {
              request.headers['authorization'] = response.data.accessToken
              return request
            }).catch(error => Promise.reject(error))
        } else {
          return request
        }*/
      }, error => {
        return Promise.reject(error)
      });

      this.instance.interceptors.response.use(
          response => {
            return response;
          },
          function(error) {
            //EventBus.$emit('error-notify', error);
            if (error.response.status === 401) {
              $store.dispatch('user/setLoginState', {login: false});
              $router.push({name:'login'});
            }
            return Promise.reject(error);
          }
      );

      return this.instance;
    }
    return this.instance
  }
}
